import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=47ad5e8a&scoped=true&"
import script from "./CustomerData.vue?vue&type=script&lang=ts&"
export * from "./CustomerData.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=47ad5e8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad5e8a",
  null
  
)

export default component.exports